import { OPEN_MODAL_PRODUCT } from '../actionTypes';
import { actions } from '../reducer';

import resetForm from './resetForm';

export default (value) => (dispatch) => {
    dispatch(actions[OPEN_MODAL_PRODUCT](value));
    if (!value) dispatch(resetForm());
};
